import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Search } from 'src/app/model/search/search.model';
import { SearchService } from 'src/app/services/http/search/search.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private service: SearchService, private router: Router) { }
  public searchData !: string;
  public searchResults !: Search;

  public nbPages !: number;
  public nbsearchResults !: number
  public p: any = 0;

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(routeParams => {
      this.searchData = routeParams.searchdata;

      /** Load the search response */
      this.getSearch(this.p)
      /** get the number of results and number of pages */
      this.service.getSearchData(this.searchData, '0').subscribe((searchResponse) => {
        this.nbsearchResults = searchResponse.results_count;
        this.nbPages = Math.ceil(searchResponse.results_count / 30);
      });
    })


  }


  /**
   * 
   * @param results Results from search request
   * @returns Modified results with correct url for GMAO and maticon for view
   */
  public getCorrectResultsUrl(results: Search) {
    for (let i = 0; i < results.results.length; i++) {
      const id = results.results[i].url.split('id=')[1];
      switch (results.results[i].type) {
        case 'installation':
          results.results[i].url = id;
          results.results[i].maticon = 'flag';
          break;
        case 'mat_unite':
          results.results[i].url = id; //Not used yet
          results.results[i].type = 'materiel';
          results.results[i].maticon = 'dashboard';
          break;
        case 'kb_article':
          results.results[i].url = id; //Not used yet
          results.results[i].type = 'wiki';
          results.results[i].maticon = 'emoji_objects';
          break;
        case 'societe':
          results.results[i].url = id; //Not used yet
          results.results[i].type = 'company';
          results.results[i].maticon = 'business';
          break;
        case 'machine':
          results.results[i].url = id; //Not used yet
          results.results[i].maticon = 'point_of_sale';
          break;
        default:
          results.results[i].url = id; //We missed this
          results.results[i].type = 'unknown';
          results.results[i].maticon = 'question_mark';
          break;
      }


    }

    return results
  }

  onClickResult(type: string, id: string) {
    this.router.navigate([type, id]);
  }

  public pageChange(e: any) {
    this.p = e;
    this.getSearch((this.p) - 1);
  }

  public getSearch(page: any) {
    this.service.getSearchData(this.searchData, page).subscribe(
      (searchResponse) => {
        searchResponse = this.getCorrectResultsUrl(searchResponse);
        this.searchResults = searchResponse;

      });
  }



}
